<template>
  <div class="rt-collapse">
    <div class="rt-collapse-header" @click="collapseClick">
      <rt-icon
        :name="showContent ? 'rt-base-angle_up' : 'rt-base-angle_down'"
        size="18"
      />
      <p>{{ title }}</p>
    </div>
    <div class="rt-collapse-content">
      <rt-collapse-transition>
        <template v-show="showContent">
          <slot />
        </template>
      </rt-collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtCollapse',
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showContent: this.show
    };
  },
  methods: {
    collapseClick(val) {
      this.showContent = !this.showContent;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCollapse.vue?63940261